import axios from './BaseService';

const TODAY_URL = `${process.env.REACT_APP_API_URL}/today`;

export async function getPresets() {
    const response = await axios.get(`${TODAY_URL}/presets`);
    return response.data;
}

export async function getMinBudget(symbol) {
    const response = await axios.get(`${TODAY_URL}/minbudget?symbol=${symbol}`);
    return response.data;
}

export async function getActiveSessions() {
    const response = await axios.get(`${TODAY_URL}/active`);
    return response.data;
}

export async function getHistory() {
    const response = await axios.get(`${TODAY_URL}/history`);
    return response.data;
}

export async function startSession(payload) {
    const response = await axios.post(`${TODAY_URL}/start`, payload);
    return response.data;
}

export async function stopSession(id) {
    const response = await axios.post(`${TODAY_URL}/stop/${id}`, {});
    return response.data;
}

// ----- System default templates (SAFE/MEDIUM/FAST) -----

export async function getTemplates() {
    const response = await axios.get(`${TODAY_URL}/templates`);
    return response.data;
}

export async function updateTemplate(id, payload) {
    const response = await axios.patch(`${TODAY_URL}/templates/${id}`, payload);
    return response.data;
}

export async function startTemplate(id, payload) {
    const response = await axios.post(`${TODAY_URL}/templates/${id}/start`, payload || {});
    return response.data;
}

export async function pauseTemplate(id) {
    const response = await axios.post(`${TODAY_URL}/templates/${id}/pause`, {});
    return response.data;
}
